
<nav>
  <ul>
    @for (item of menus; track item; let i = $index) {
      <div id="{{copyMenuList[i].Name}}" [ngClass]="_cs.isPasscodeExpired && item.RoutingURL != '/passcode' &&  item.RoutingURL != '/login' ? 'disable-field' : item.RoutingURL == '/passcode' && (!_cs.isMasterSyncComplete || !IsAdUSerLoggedIn || !_cs.isonlineStatus) ? 'disable-field' : ''">
        @if (item.hasOwnProperty('Visible') ? item.Visible :true ) {
          <li routerLinkActive="active-link" class="table-class"  (click)="selectedMenuItem(i, item)" (mouseover)="openPage(i)" (mouseout)="undoSelection(i)" [ngClass]="[ i == selectedMenu ? 'add-hover':'',i == hoveredMenu ?'add-hover':'',i==activeMenu?'activeMenu':'', item.hasOwnProperty('Enabled') ? !item.Enabled ? 'disabled' : '' :'' ]">
            <div class="tablecell-class menu-section">
              <a  class="" [ngClass]="[i==activeMenu?'activeMenuHighLight':'']"><i class="icon-{{item.Icon}}"></i><span class="name">{{item.Name}}</span>@if (item.RoutingURL == '/passcode' && _cs.tempCanshowpasscodepopup) {
              <i class="icon-Alert evenspace"></i>
            }</a>
          </div>
      </li>
    }
  </div>
}

</ul>
</nav>